"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbNavigation = exports.BreadcrumbSeparator = exports.BreadcrumbContainer = exports.BreadcrumbItem = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var Breadcrumb_1 = require("./Breadcrumb");
exports.BreadcrumbItem = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tcolor: #ffffff;\n\t\tdisplay: inline-block;\n\t}\n"], ["\n\t {\n\t\tcolor: #ffffff;\n\t\tdisplay: inline-block;\n\t}\n"])));
exports.BreadcrumbItem.displayName = 'BreadcrumbItem';
// TODO: the absolute style rule should be removed when the breadcrumbs are more holistically incorporated
// 		 into the layout. It is a temporary hack to align the breadcrumbs with the top header bar.
exports.BreadcrumbContainer = styled_components_1.default.span.attrs({
    className: 'tws-breadcrumbs',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t {\n\t\t", "\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tline-height: 13px;\n\n\t\tposition: absolute;\n\t\tleft: 30px;\n\t\ttop: 130px;\n\t\tmax-width: 55%;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t}\n"], ["\n\t {\n\t\t", "\n\t\tfont-size: 12px;\n\t\tfont-weight: 500;\n\t\tline-height: 13px;\n\n\t\tposition: absolute;\n\t\tleft: 30px;\n\t\ttop: 130px;\n\t\tmax-width: 55%;\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t}\n"])), globalCss_1.bodyCopyXSmall);
exports.BreadcrumbContainer.displayName = 'BreadcrumbContainer';
exports.BreadcrumbSeparator = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t {\n\t\tdisplay: inline-block;\n\t\tpadding: 0 5px;\n\t}\n"], ["\n\t {\n\t\tdisplay: inline-block;\n\t\tpadding: 0 5px;\n\t}\n"])));
exports.BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';
var BreadcrumbNavigation = /** @class */ (function (_super) {
    __extends(BreadcrumbNavigation, _super);
    function BreadcrumbNavigation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BreadcrumbNavigation.prototype.render = function () {
        var _this = this;
        var levels = this.props.levels;
        if (!levels.length) {
            return null;
        }
        var addSeparator = function (index) { return index !== levels.length - 1; };
        return (React.createElement(exports.BreadcrumbContainer, { className: this.props.className }, levels
            .sort(function (a, b) { return a.sequence - b.sequence; })
            .map(function (level, index) { return (React.createElement(exports.BreadcrumbItem, { key: index },
            React.createElement(Breadcrumb_1.Breadcrumb, { label: level.label, active: index === levels.length - 1, onClick: function () { return _this.onClick(index === levels.length - 1, level.route, level.subroute); } }),
            addSeparator(index) && React.createElement(exports.BreadcrumbSeparator, null, "/"))); })));
    };
    BreadcrumbNavigation.prototype.onClick = function (active, route, subroute) {
        if (!active) {
            this.props.navigation(route, subroute);
        }
    };
    return BreadcrumbNavigation;
}(React.Component));
exports.BreadcrumbNavigation = BreadcrumbNavigation;
var templateObject_1, templateObject_2, templateObject_3;
